import styled from "styled-components";

import { primaryPalette } from "../onboarding/webStyleUtils";

// We use a different media query since we have a fixed box size of 500px that we want to break
// before we hit
export const ONBOARDING_MEDIA_QUERY_BREAKPOINT = 550;

export const SubmitContainer = styled.div<{ $alignActionRight?: boolean }>`
  display: flex;
  justify-content: ${({ $alignActionRight }) =>
    $alignActionRight && "flex-end"};
  gap: 10px;
`;

export const StepNumber = styled.div`
  background-color: ${({ theme }) => primaryPalette(theme, "400")};
  color: ${({ theme }) => theme.marketingColors.ROSE_QUARTZ};
  font-size: ${({ theme }) => theme.fontSize.SMALL};
  padding: 4px 8px;
  width: fit-content;
  margin-bottom: 16px;
  font-variant-numeric: tabular-nums;
`;

export const MultiSelectionContainerFlex = styled.div`
  display: flex;
  gap: 8px;
  > * {
    flex: 1;
  }

  @media (max-width: ${ONBOARDING_MEDIA_QUERY_BREAKPOINT}px) {
    flex-direction: column;
  }
`;

export const MultiSelectionContainerGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 8px;

  @media (max-width: ${ONBOARDING_MEDIA_QUERY_BREAKPOINT}px) {
    grid-template-columns: 1fr;
  }
`;
